// extracted by mini-css-extract-plugin
export var circleBg = "LogoWithCircleBackground_circleBg__nb4yO";